export enum ThemeTypes {
    DEFAULT = 'default',
    LIGHT = 'light',
    VEM = 'vem',
}
